import React, { FC } from 'react';
import Card from '../../../../../../components/Card';
import CustomersTable from '../CustomersTable';
import { createUseStyles } from '../../../../../../theming';
import { LegacyCustomer } from '../../../../../../interfaces/api/Customer';
import { Order } from '../../../../../../interfaces/Table';
import clsx from 'clsx';

const useStyles = createUseStyles({
  root: {},
  searchCard: {
    maxHeight: '100%',
  },
});

interface Props {
  className: any;
  maxHeight: number;
  customers: LegacyCustomer[];
  orderBy: keyof LegacyCustomer;
  order: Order;
  onRequestSort: (event: React.MouseEvent<unknown>, property: keyof LegacyCustomer) => void;
}

const CustomersListCard: FC<Props> = ({ className, maxHeight, orderBy, order, customers, onRequestSort }) => {
  const classes = useStyles();

  return (
    <div className={clsx(className, classes.root)}>
      <Card className={classes.searchCard}>
        <CustomersTable
          maxHeight={maxHeight}
          orderBy={orderBy}
          order={order}
          customers={customers}
          onRequestSort={onRequestSort}
        />
      </Card>
    </div>
  );
};

export default CustomersListCard;
